import { ProjectQuery } from '~/@store/projects';
import { CreateDeliveryLineFromProjectMutation as mutation } from '~/@user-store/deliveryLines/deliveryLine.queries';
import * as deliveryLineQueries from '~/@user-store/deliveryLines/deliveryLine.queries';
import client from '~/apolloClient';
import {
    ChangeDeliveryLineOrderMutation,
    ChangeDeliveryLineOrderMutationVariables,
    CreateDeliveryLineFromProjectMutation,
    CreateDeliveryLineFromProjectMutationVariables,
    DeliveryLineDeleteMutation,
    DeliveryLineDeleteMutationVariables,
    DeliveryLineOrderChangeInput,
    DeliveryLineSenderCreateInput,
    DeliveryLineSenderUpdateInput,
    UpdateDeliveryLineFromProjectMutation,
    UpdateDeliveryLineFromProjectMutationVariables,
} from '~/graphql';
import { handleApolloError } from '~/utils';

export const createDeliveryLineFromProject = (projectId: string, input: DeliveryLineSenderCreateInput) =>
    client
        .mutate<CreateDeliveryLineFromProjectMutation, CreateDeliveryLineFromProjectMutationVariables>({
            mutation,
            variables: { input },
            refetchQueries: [
                {
                    query: ProjectQuery,
                    variables: { id: projectId },
                },
            ],
        })
        .catch(handleApolloError)
        .then(res => res.data?.deliveryLineSenderCreate || Promise.reject(new Error('empty response')));

export const updateDeliveryLineFromProject = (projectId: string, input: DeliveryLineSenderUpdateInput) =>
    client
        .mutate<UpdateDeliveryLineFromProjectMutation, UpdateDeliveryLineFromProjectMutationVariables>({
            mutation: deliveryLineQueries.UpdateDeliveryLineFromProjectMutation,
            variables: { input },
            refetchQueries: [
                {
                    query: ProjectQuery,
                    variables: { id: projectId },
                },
            ],
        })
        .catch(handleApolloError)
        .then(res => res.data?.deliveryLineSenderUpdate || Promise.reject(new Error('empty response')));

export const changeDeliveryLineOrder = (input: DeliveryLineOrderChangeInput) =>
    client
        .mutate<ChangeDeliveryLineOrderMutation, ChangeDeliveryLineOrderMutationVariables>({
            mutation: deliveryLineQueries.ChangeDeliveryLineOrderMutation,
            variables: { input },
        })
        .catch(handleApolloError)
        .then(res => res.data?.deliveryLineOrderChange || Promise.reject(new Error('empty response')));

export const deleteDeliveryLineFromProject = (projectId: string, id: string) =>
    client
        .mutate<DeliveryLineDeleteMutation, DeliveryLineDeleteMutationVariables>({
            mutation: deliveryLineQueries.DeleteDeliveryLineFromProjectMutation,
            variables: { id },
            refetchQueries: [
                {
                    query: ProjectQuery,
                    variables: { id: projectId },
                },
            ],
        })
        .catch(handleApolloError);
